import { useBackground, useShell } from '../../layout'
import { Body, Box, Button, CenteredBox, H3 } from '../../widgets'
import { assetUrl } from '../../../utilities.js'

export const Exited = ({ active }) => {
  useShell({ active, mode: 'logo' })
  useBackground().set({ active, background: 1, size: '2072px 2035px', position: '-850px -240px' })

  const open = url => () => window.open(url)

  return (
    <CenteredBox
      fullWidth
      height="100dvh"
      p={32}
    >
      <Box position="absolute" inset background={`var(--black-fade), url(${assetUrl('gifs/confetti.gif')}) center / 900px 1200px`} />

      <Box column fullWidth zIndex={1} gap={32}>
        <H3>Thank you for playing!</H3>
        <Body lineHeight={1.5}>Loved this experience? Discover our other products and learn everything you need to know about Shivoo on our website.</Body>
        <Box fullWidth column gap={16}>
          <Button onClick={open('https://shivoo.io/')}>
            shivoo.io
          </Button>
          <Button onClick={open('https://www.podandhive.com/')}>
            Explore Pod&Hive
          </Button>
        </Box>
      </Box>
    </CenteredBox>
  )
}